import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {ThreadType} from 'nutshell-graphql-types';
import type {GetForm_form_createRules_lead as CreateRulesLeadFragment} from 'nutshell-graphql-types';

import {CreateRulesCardLead} from '../../forms/form-page/create-rules/create-rules-card-lead';

import {PhoneNumberCard} from '../sms/inbound/phone-number-card';

import {RuleCard} from './rule-card';

type Props = {
    createRules: CreateRulesLeadFragment | null | undefined;
    setCreateRulesSidebar: (arg1: boolean) => void;
    redirectPhoneNumber: string | null | undefined;
    showRedirectNumberSidebar: (arg1: boolean) => void;
    isEmbedded?: boolean;
    threadType: ThreadType;
    hasNewColumnLayout?: boolean;
};

export function Rules(props: Props) {
    return (
        <StackLegacy spacing={16}>
            {!props.isEmbedded &&
                (props.hasNewColumnLayout ? (
                    <RuleCard
                        emptyCard={
                            <EmptyAddCard
                                background='white'
                                size='small'
                                text='Create a lead'
                                onClick={() => props.setCreateRulesSidebar(true)}
                                withoutIcon={true}
                                height={50}
                            />
                        }
                        rulesCard={
                            props.createRules && (
                                <CreateRulesCardLead
                                    onClick={() => props.setCreateRulesSidebar(true)}
                                    createRules={props.createRules}
                                />
                            )
                        }
                    />
                ) : (
                    <LabelWithContent
                        label='Lead creation'
                        sublabel={`Automatically create a lead in Nutshell when a message is received.`}
                        spacing={8}
                        content={
                            <RuleCard
                                emptyCard={
                                    <EmptyAddCard
                                        background='white'
                                        size='small'
                                        text='Create a lead'
                                        onClick={() => props.setCreateRulesSidebar(true)}
                                        withoutIcon={true}
                                        height={50}
                                    />
                                }
                                rulesCard={
                                    props.createRules && (
                                        <CreateRulesCardLead
                                            onClick={() => props.setCreateRulesSidebar(true)}
                                            createRules={props.createRules}
                                        />
                                    )
                                }
                            />
                        }
                    />
                ))}
            {props.threadType === 'SMS' && (
                <LabelWithContent
                    label='Redirect phone calls'
                    sublabel='When a phone number tries to call your company phone number, the phone call will redirect to this number.'
                    spacing={8}
                    content={
                        <RuleCard
                            emptyCard={
                                <EmptyAddCard
                                    background='white'
                                    size='small'
                                    text='Add a redirect phone number'
                                    onClick={() => props.showRedirectNumberSidebar(true)}
                                    withoutIcon={true}
                                    height={50}
                                />
                            }
                            rulesCard={
                                props.redirectPhoneNumber && (
                                    <PhoneNumberCard
                                        onClick={() => props.showRedirectNumberSidebar(true)}
                                        phoneNumber={props.redirectPhoneNumber}
                                    />
                                )
                            }
                        />
                    }
                />
            )}
        </StackLegacy>
    );
}
